import { cloneElement, isValidElement } from "react";
import type { ReactNode, ReactElement, HTMLAttributes } from "react";
import type { ButtonProps } from "./Button";
import clsx from "clsx";

type Props = {
  icon: ReactNode;
  size: NonNullable<ButtonProps["size"]>;
};

const iconSizeClassMap: Record<NonNullable<ButtonProps["size"]>, string> = {
  small: "w-[14px] h-[14px]",
  medium: "w-4 h-4",
  large: "w-[18px] h-[18px]",
};

const ButtonIcon = ({ icon, size }: Props) => {
  if (!icon) return null;

  const wrapperClass = iconSizeClassMap[size];

  if (typeof icon === "string") {
    return (
      <span className={wrapperClass}>
        <span className="flex justify-center items-center w-full h-full text-inherit">{icon}</span>
      </span>
    );
  }

  if (isValidElement(icon)) {
    const iconWithClassName = icon as ReactElement<Partial<HTMLAttributes<HTMLElement>> & { className?: string }>;
    return (
      <span className={wrapperClass}>
        {cloneElement(iconWithClassName, {
          className: clsx("w-full h-full", iconWithClassName.props.className),
        })}
      </span>
    );
  }

  return <div className={wrapperClass}>{icon}</div>;
};

export default ButtonIcon;
